import "./Footer.css";
import React, { useState } from "react";
import axios from "axios";

const Footer = () => {
  const [email, setEmail] = useState("");

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      alert("กรุณากรอกอีเมลก่อนกดส่ง");
      return;
    }

    try {
       await axios.post("/contactus/v1", {
        email,
      });
      alert("Email sent successfully!");
      setEmail("");
    } catch (error) {
      console.error("Error sending email:", error);
      alert("Failed to send email.");
    }
  };


  return (
    <footer className="footer">
      <div className="footer-section contact">
        <h3>GET IN TOUCH</h3>
        <p>
          Join our mailing list to stay up to date and get notices about our new
          releases!
        </p>
        <div className="email-form">
          <form onSubmit={handleSubmit}>
            <input
              type="email"
              value={email}
              onChange={handleEmailChange}
              placeholder="mail@example.com"
            />
            <button type="submit">Send</button>
          </form>
        </div>
      </div>
      <div className="footer-section follow-us">
        <h3>FOLLOW US</h3>
        <div className="social-icons1">
          <a
            href="https://www.facebook.com/proscopeit/"
            className="icon facebook"
            target="_blank"
            rel="noopener noreferrer"
          >
            f
          </a>
          <a
            href="https://www.linkedin.com/company/proscope-co.-ltd"
            className="icon linkedin"
            target="_blank"
            rel="noopener noreferrer"
          >
            in
          </a>
        </div>
      </div>

      <div className="footer-section company-info">
        <h3>PROSCOPE</h3>
        <p>
          Please feel free to contact us anytime if you are interested in our
          products.
        </p>
        <p>
          <strong>Phone Number:</strong> +66 2623 0491
        </p>
        <p>
          <strong>Email:</strong>  {""}
          <a href="mailto:sales@proscope.co.th" style={{ color: 'white' }}>
           sales@proscope.co.th
          </a>

        </p>

      </div>
      <div className="footer-bottom">
        <p>© 2025 PROSCOPE CO., LTD. - ALL RIGHTS RESERVED</p>
      </div>
    </footer>
  );
};

export default Footer;
